import type { Booking, BookingSource, BookingStatus } from '@/lib/types/booking'

export const BOOKING_STATUSES: BookingStatus[] = [
  'request',
  'approved',
  'arrived',
  'in_delivery',
  'seated',
  'left',
  'no_show',
  'canceled',
  'waitlist',
]

export const BOOKING_SOURCES: BookingSource[] = [
  'api',
  'email',
  'facebook',
  'google',
  'import',
  'instagram',
  'message',
  'other',
  'phone',
  'walkin',
  'website',
  'she_answers',
  'collection',
]

export function bookingTableDocumentIds(booking?: Booking | null) {
  return (booking?.bookingTables ?? [])
    .map((bt) => bt.table?.documentId)
    .filter((id): id is string => Boolean(id))
}

export function bookingTableNames(booking?: Booking | null) {
  return (booking?.bookingTables ?? [])
    .map((bt) => bt.name || bt.table?.name)
    .filter((name): name is string => Boolean(name))
}

export function hasBookingTables(booking?: Booking | null) {
  return (booking?.bookingTables ?? []).length > 0
}

export function hasUsableBookingTable(booking?: Booking | null) {
  return bookingTableDocumentIds(booking).length > 0
}

export function hasBrokenBookingTableRefs(booking?: Booking | null) {
  const bookingTables = booking?.bookingTables ?? []
  return bookingTables.length > 0 && bookingTables.every((bt) => !bt.table)
}
